// Site Sections
export const SITE_SECTION_WELCOME = "welcome";

// Page Names
export const PAGE_NAME_WELCOME = "welcome";

// Link Names
export const LINK_NAME_ABOUT_US_CLICK = "about us click";
export const LINK_NAME_PRIVACY_POLICY_CLICK = "privacy policy click";

// Platforms
export const PLATFORM_SMB_ELVN = "smb elvn";
export const PLATFORM_SMB_ELAVON_DOTCOM = "smb elavon dotcom";